import { render, staticRenderFns } from "./Examcopy.vue?vue&type=template&id=d14d4b96&scoped=true&"
import script from "./Examcopy.vue?vue&type=script&lang=js&"
export * from "./Examcopy.vue?vue&type=script&lang=js&"
import style0 from "./Examcopy.vue?vue&type=style&index=0&id=d14d4b96&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d14d4b96",
  null
  
)

export default component.exports